import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {Card, Form} from "reactstrap";
import {useSelector, useDispatch} from "react-redux";
import SelectCreator from "../../../components/Forms/components/SelectCreator";
import InputCreator from "../../../components/Forms/components/InputCreator";
import {
  storeCreateTemplateData,
  requestTemplateControllers,
} from "../../../redux/Actions/reports.actions";
import {
  getCreateTemplateData,
  getTemplateControllerList,
} from "../../../redux/Selectors/reports.selectors";

const AddTemplateForm = () => {
  const dispatch = useDispatch();
  const {templateId} = useParams();
  const createTemplateData = useSelector(getCreateTemplateData);
  const {name = "", inventory = "", description = "", id} = createTemplateData;

  const templateControllersList = useSelector(getTemplateControllerList);

  useEffect(() => {
    dispatch(requestTemplateControllers(id !== undefined));
  }, [dispatch, id]);

  const onChangeHandler = (e) => {
    const {target} = e;
    const {name, value} = target;
    let updateObj = {...createTemplateData};
    if (name === "inventory") {
      const appliance = templateControllersList.find((item) => item.value === value);
      updateObj = Object.assign({}, updateObj, {appliance, [name]: value});
    } else {
      updateObj = Object.assign({}, updateObj, {[name]: value});
    }
    dispatch(storeCreateTemplateData(updateObj));
  };

  return (
    <Card style={{padding: "1rem 0px", boxShadow: "0px 3px 6px #00000029"}}>
      <div
        className="roboto-bold"
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          borderBottom: "1px solid #20C1FF",
          margin: "0px 1rem 1rem 1rem",
          color: "#303030",
          paddingBottom: "5px",
        }}
      >
        {`${templateId ? "Edit" : "Add"} Template`}
      </div>
      <Form>
        <InputCreator
          large
          inSingleRow
          label={"Name"}
          isRequired
          onChange={onChangeHandler}
          value={name}
          name={"name"}
          placeholder="Enter Name"
          style={{
            border: "1px solid #d6d6d6",
            maxHeight: "38px",
            boxShadow: "none",
          }}
          data-cy="templateName"
        />
        <SelectCreator
          inSingleRow
          label={"Appliance"}
          isRequired
          closeMenuOnSelect={true}
          name={"inventory"}
          options={templateControllersList}
          onChange={onChangeHandler}
          value={inventory}
          colSize={12}
          placeholder={"Select Appliance"}
          classNamePrefix={"selectInventory"}
          id={"selectInventory"}
          isDisabled={id}
          help_text="If appliance is already used in the template that appliance will not be available for selection"
        />
        <InputCreator
          large
          inSingleRow
          label={"Description"}
          value={description}
          name={"description"}
          onChange={onChangeHandler}
          placeholder="Add Your Description"
          style={{
            border: "1px solid #d6d6d6",
            maxHeight: "38px",
            boxShadow: "none",
          }}
        />
      </Form>
    </Card>
  );
};

export default AddTemplateForm;
